import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { Loading, Nav, Hint } from "@/components";
import { StoreUserModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Store, Common } from "@/constant";

import { UserInfo } from "@/types/Login";

import { Priv } from "@/util/Priv";
import { DefaultPath } from "@/constant/GroupPermission";

@Component<StoreUserAddController>({
    components: {
        Loading,
        Nav,
        Hint,
    }
})
export default class StoreUserAddController extends Vue {
    private isLoading = true;

    private expireTime = 0;
    private accountTypeMap = Store.AccountTypeMap;
    private storeUserInfo = TCBReceiptApi.Protobuf.StoreUser.create({ type: 1, });
    private selectMap: { [key: string]: TCBReceiptApi.Protobuf.IStoreList } = {};

    /* 權限 */
    private tidNumberPermission: {
        sn: string;
        tidNumber: string;
        allSelected: boolean;
        storeList: {
            id: number;
            code: string;
            name: string;
            selected: boolean;
        }[];
        show: boolean;
    } = {
            sn: "",
            tidNumber: "",
            allSelected: false,
            storeList: [],
            show: false
        };

    private selectedStoreRadio = 0;
    private selectedTidNumberCheckbox: number[] = [];
    /* 權限 */

    // Hint
    private isDone = false;
    private hintBox: { show: boolean, hint: string } = { show: false, hint: "" };

    public async created() {
        /* 取得最新的權限map並判斷有何權限 */
        await this.setPriv();
        /* 取得最新的權限map並判斷有何權限 */

        this.isLoading = true;

        // 取得該特店帳號下(統編)的特店清單列表 製作權限勾選列表
        const userInfo: UserInfo = JSON.parse(Cookies.get("appUserInfo") as string);
        const tidNumber = userInfo.identification as string;
        console.log("tidNumber");
        console.log(tidNumber);

        await this.getTIDNumberPermission(tidNumber);
        
        console.log("tidNumberPermission");
        console.log(this.tidNumberPermission);

        this.isLoading = false;
    }

    private async getTIDNumberPermission(tidNumber: string) {
        this.isLoading = true;

        // 取得該特店帳號下(統編)的特店清單列表
        const item = TCBReceiptApi.Protobuf.StoreUserQuery.create({
            identification: tidNumber,
        });
        console.log(item);

        const storeUserQuery = TCBReceiptApi.Protobuf.StoreUserQuery.encode(item).finish();
        const storeUserPermissionList = await StoreUserModel.getPermissionMap(storeUserQuery);
        console.log("storeUserPermissionList");
        console.log(storeUserPermissionList);

        this.isLoading = false;

        this.tidNumberPermission.sn = "0001";
        this.tidNumberPermission.tidNumber = tidNumber;

        this.tidNumberPermission.storeList = [];
        const storeList = storeUserPermissionList.list;
        console.log("storeList");
        console.log(storeList);
        storeList.forEach((store, index) => {
            const item = {
                id: store.storeId as number,
                code: store.storeCode as string,
                name: store.registerName as string,
                selected: false
            };
            this.tidNumberPermission.storeList.push(item);
        });

        this.tidNumberPermission.show = true;

        this.setInfo(this.selectedStoreRadio);
    }

    private async submit() {
        console.log("submit");
        console.log(this.storeUserInfo);
        console.log("radio");
        console.log(this.selectedStoreRadio);
        console.log("checkbox");
        console.log(this.selectedTidNumberCheckbox);

        if (this.storeUserInfo.type === 2 && this.selectedTidNumberCheckbox.length === 0) {
            this.openHint("請選取特店");
            return false;
        }

        // 權限轉換成勾選狀態
        if (this.storeUserInfo.type === 1) {
            this.tidNumberPermission.storeList[this.selectedStoreRadio].selected = true;
        } else if (this.storeUserInfo.type === 2) {
            this.selectedTidNumberCheckbox.forEach(index => {
                this.tidNumberPermission.storeList[index].selected = true;
            });
        } else {
            this.openHint("帳號類型錯誤");
            return false;
        }

        /* 加入權限 */
        console.log("目前的 tidNumberPermission");
        console.log(this.tidNumberPermission);

        const permission: { [storeCode: string]: TCBReceiptApi.Protobuf.StoreUserPermissionList } = {}; // 以特店代號為索引的map
        const storeUserPermissionList = TCBReceiptApi.Protobuf.StoreUserPermissionList.create();
        let recordStoreCode = "";

        this.tidNumberPermission.storeList.forEach(thisStore => {
            if (thisStore.selected) {
                // 使用者選擇的特店資訊
                const storeUserPermission = TCBReceiptApi.Protobuf.StoreUserPermission.create({
                    storeId: thisStore.id as number,
                    storeCode: thisStore.code as string,
                    tidNumber: this.tidNumberPermission.tidNumber as string,
                    registerName: thisStore.name as string,
                });

                // 權限陣列
                storeUserPermissionList.list.push(storeUserPermission);

                recordStoreCode = thisStore.code as string;
            }
        });

        // 帳號權限
        permission[this.tidNumberPermission.tidNumber] = storeUserPermissionList;
        this.storeUserInfo.permission = permission;
        /* 加入權限 */

        // send value
        const item = TCBReceiptApi.Protobuf.StoreUser.create({
            type: this.storeUserInfo.type,
            identification: this.storeUserInfo.identification,
            permission: this.storeUserInfo.permission,
            motify: TCBReceiptApi.Protobuf.StoreUserMotify.create(),
            storeCode: (this.storeUserInfo.type === 1) ? this.storeUserInfo.identification as string : recordStoreCode as string,
            tidNumber: this.tidNumberPermission.tidNumber as string,
        });
        console.log("item");
        console.log(item);

        const storeUser = TCBReceiptApi.Protobuf.StoreUser.encode(item).finish();
        const errorCode = await StoreUserModel.addStoreUser(storeUser);
        this.isLoading = false;

        console.log("errorCode");
        console.log(errorCode);
        if (errorCode === TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS) {
            this.isDone = true;
        }

        this.openHint(Common.ErrorCodeMap[errorCode]);
    }

    private changeAccType() {
        const thisStoreInfo = this.tidNumberPermission.storeList[this.selectedStoreRadio];

        if (this.storeUserInfo.type === 1) {
            this.storeUserInfo.identification = thisStoreInfo.code as string;
            this.storeUserInfo.registerName = thisStoreInfo.name as string;
        } else if (this.storeUserInfo.type === 2) {
            console.log(this.tidNumberPermission.tidNumber);
            this.storeUserInfo.identification = this.tidNumberPermission.tidNumber as string;
            this.storeUserInfo.registerName = thisStoreInfo.name as string; // 來自登入帳號的？
        }

        return false;
    }

    private setInfo(index: number) {
        if (this.tidNumberPermission.storeList.length === 0) {
            return false;
        }

        const thisStoreInfo = this.tidNumberPermission.storeList[index];
        this.storeUserInfo.identification = thisStoreInfo.code as string;
        this.storeUserInfo.registerName = thisStoreInfo.name as string;
    }

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        if (this.isDone) {
            this.hintBox.show = false;
            this.hintBox.hint = "";
            this.$router.push("/store/user/list");
        } else {
            this.hintBox.show = false;
            this.hintBox.hint = "";
        }
    }
    /* Hint */

    /* 取得最新的權限map並判斷有何權限 */
    private async setPriv() {
        const meta = this.$route.meta as { privKey: { controller: string, method: string, type: string } };
        console.log(meta);

        const isSetPriv = await Priv._checkPriv(meta.privKey);
        if (!isSetPriv) {
            this.$router.push(DefaultPath);  // priv
        }

        if (!Priv._checkPrivType(meta.privKey.type)) {
            this.$router.push(DefaultPath);  // priv
        }

        this.expireTime = Priv._getExpireTime();        
    }
    /* 取得最新的權限map並判斷有何權限 */
}
